import { render, staticRenderFns } from "./RadOrderDetail.vue?vue&type=template&id=54617adb"
import script from "./RadOrderDetail.vue?vue&type=script&lang=js"
export * from "./RadOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./RadOrderDetail.vue?vue&type=style&index=0&id=54617adb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports